"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateTrial = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Raven = _interopRequireDefault(require("Raven"));

var _I18n = _interopRequireDefault(require("I18n"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Trials = require("self-service-api/constants/Trials");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _startTrial = require("ui-addon-upgrades/_core/common/api/startTrial");

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var activateTrial = (0, _wrapWithErrorMonitoring.default)('activateTrial', function (upgradeData, mon339Treatment) {
  var trialId = upgradeData.trialId,
      upgradeProduct = upgradeData.upgradeProduct,
      source = upgradeData.source; // Default to 14-day trials if no default specified

  var defaultDurationInDays;

  if (mon339Treatment === 'variation') {
    defaultDurationInDays = 14;
  } else {
    defaultDurationInDays = _Trials.upgradeProductToDefaultDuration[upgradeProduct] || 14;
  }

  var endDate = _I18n.default.moment().add(defaultDurationInDays, 'days').valueOf();

  return (0, _startTrial.startTrial)(trialId, endDate, source).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', (0, _extends2.default)({
      //Temporary override for remote tools so it is not treated as a trial activation success / QL
      action: upgradeProduct === _UpgradeProducts.TEMPORARY_REMOTE_TOOLS ? 'remote tools activation succeeded' : 'activation succeeded'
    }, upgradeData));
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', (0, _extends2.default)({
      action: 'activation failed'
    }, upgradeData));

    _devLogger.default.warn({
      message: e,
      key: 'TrialActivationButton'
    });

    _Raven.default.captureMessage('Trial activation failed', {
      extra: {
        error: e
      }
    });

    throw e;
  });
});
exports.activateTrial = activateTrial;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/trial/activateTrial.js
// module id = 745
// module chunks = 5 6